import script from "./EmptyIllustration.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyIllustration.vue?vue&type=script&setup=true&lang=js"

import "./EmptyIllustration.vue?vue&type=style&index=0&id=289ad748&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-289ad748"]])

export default __exports__